import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { ScanLine, Megaphone, Check } from "lucide-react";

const AddonsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-24 md:py-32" ref={ref}>
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-16"
        >
          <span className="text-sm font-mono text-secondary uppercase tracking-widest">Recursos adicionais</span>
          <h2 className="text-3xl md:text-5xl font-bold mt-4">
            Potencialize seus <span className="gradient-text">resultados.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.2 }}
            className="glass-card rounded-2xl p-8"
          >
            <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center mb-4">
              <ScanLine className="w-6 h-6 text-secondary" />
            </div>
            <h3 className="font-bold text-lg mb-1">Rastreamento profissional</h3>
            <p className="text-2xl font-bold mb-1">R$ 500</p>
            <p className="text-sm text-muted-foreground mb-4">Configuração completa de tracking.</p>
            <ul className="space-y-2">
              {["Pixel Meta Ads", "Tag Google Ads", "Eventos de conversão", "Google Tag Manager"].map((f, i) => (
                <li key={i} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <Check className="w-4 h-4 text-secondary shrink-0" /> {f}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.3 }}
            className="glass-card rounded-2xl p-8"
          >
            <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
              <Megaphone className="w-6 h-6 text-primary" />
            </div>
            <h3 className="font-bold text-lg mb-1">Gestão de tráfego pago</h3>
            <p className="text-sm text-muted-foreground mb-1">A partir de</p>
            <p className="text-2xl font-bold mb-4">R$ 700<span className="text-sm font-normal text-muted-foreground">/mês</span></p>
            <p className="text-sm text-muted-foreground">
              Nossa equipe cria e otimiza campanhas no Google Ads e Meta Ads para gerar clientes para o seu negócio.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AddonsSection;
